import { render } from "./MiniWizardItem.vue?vue&type=template&id=0c7d771c"
import script from "./MiniWizardItem.vue?vue&type=script&lang=js"
export * from "./MiniWizardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__